import LeadFormSection from './LeadFormSection';
import { lazy, Suspense } from 'react';
// The imported design library is loaded only on pages using Studio variants.
const StudioCmsSection = lazy(() => import('./StudioCmsSection'));
const { renderPremiumSection, SECTION_CSS } = require('./render.cjs');

export default function PremiumSection({ section, headingTag = 'h1', sectionIndex = 0 }) {
  if (typeof section.variant === 'string' && section.variant.startsWith('studio-')) {
    return <Suspense fallback={null}><StudioCmsSection section={section} sectionIndex={sectionIndex} /></Suspense>;
  }
  if (section.type === 'lead_form') {
    return <div className="el-premium-section">
      <style>{SECTION_CSS}</style>
      <LeadFormSection section={section} sectionIndex={sectionIndex} />
    </div>;
  }
  return <div className="el-premium-section"><style>{SECTION_CSS}</style>
    <div dangerouslySetInnerHTML={{ __html: renderPremiumSection(section, { headingTag }) }} />
  </div>;
}
